import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataSource } from '../common/types/common';

interface DiagramState {
  xmlData: any;
  useCaseData: any;
  dataSources: DataSource[];
  isFromDraft: boolean;
  isDiagramPurple?: boolean;
}

const initialState: DiagramState = {
  xmlData: null,
  useCaseData: null,
  dataSources: [],
  isFromDraft: false,
  isDiagramPurple: false,
};

const diagramSlice = createSlice({
  name: 'diagram',
  initialState,
  reducers: {
    setXmlData: (state, action: PayloadAction<any>) => {
      state.xmlData = action.payload;
      state.isFromDraft = true;
    },
    setUseCaseData: (state, action: PayloadAction<any>) => {
      state.useCaseData = action.payload;
      state.isFromDraft = true;
    },
    setDataSources: (state, action: PayloadAction<DataSource[]>) => {
      state.dataSources = action.payload;
      state.isFromDraft = true;
    },
    setDiagramPurple: (state, action: PayloadAction<boolean>) => {
      // <-- Add this reducer
      state.isDiagramPurple = action.payload;
    },
    clearDiagramData: (state) => {
      if (!state.isFromDraft) {
        state.xmlData = null;
        state.useCaseData = null;
        state.dataSources = [];
      }
    },
    resetAll: () => {
      return initialState;
    },
  },
});

export const {
  setXmlData,
  setUseCaseData,
  setDataSources,
  clearDiagramData,
  resetAll,
  setDiagramPurple,
} = diagramSlice.actions;

export default diagramSlice.reducer;
